// @flow

import { connect } from 'react-redux';
import * as Selectors from '../selectors';
import { FETCHING_REPORTS } from '../constants/async-process-names';
import ReportPage from '../components/pages/reports';
import { MY_REPORTS } from '../constants/routes';

function mapStateToProps(state, ownProps) {
  const isMyReports = ownProps && ownProps.match && ownProps.match.path === MY_REPORTS;
  const reports = isMyReports
    ? Selectors.getMyReports(state)
    : Selectors.getOrgReports(state);

  return {
    basePath: isMyReports ? MY_REPORTS : '/reports',
    reports,
    fetchingReports: Selectors.asyncProcessHappening(state, FETCHING_REPORTS),
  };
}

export default connect(mapStateToProps)(ReportPage);
